export class StaffRequestPortalService {
    constructor(http, config) {
        this.http = http;
        const servicePath = config?.servicePath ?? StaffRequestPortalService.DEFAULT_SERVICE_PATH;
        this.basePath = `${servicePath}/${StaffRequestPortalService.BASE_PATH}`;
    }
    buildUrl(path) {
        const url = path ? `${this.basePath}/${path}` : this.basePath;
        return url.startsWith('/') ? url : '/' + url;
    }
    async getMyRequests() {
        const response = await this.http.get(this.buildUrl());
        return response.data ?? [];
    }
    async getById(id) {
        const response = await this.http.get(this.buildUrl(`${id}`));
        return response.data;
    }
    async create(model) {
        const response = await this.http.post(this.buildUrl(), model);
        return response.data;
    }
    async createAndSubmit(model) {
        const response = await this.http.post(this.buildUrl('create-and-submit'), model);
        return response.data;
    }
    async update(id, request) {
        const response = await this.http.put(this.buildUrl(`${id}`), request);
        return response.data;
    }
    async submit(id) {
        const response = await this.http.put(this.buildUrl(`${id}/submit`), {});
        return response.data;
    }
    async delete(id) {
        await this.http.delete(this.buildUrl(`${id}`));
    }
    async close(id) {
        const response = await this.http.put(this.buildUrl(`${id}/close`), {});
        return response.data;
    }
}
StaffRequestPortalService.DEFAULT_SERVICE_PATH = 'procurements';
StaffRequestPortalService.BASE_PATH = 'api/procurement-portal/requests';
//# sourceMappingURL=StaffRequestPortalService.js.map